import { render, staticRenderFns } from "./MenuAuthModal.vue?vue&type=template&id=480129dc&scoped=true&"
import script from "./MenuAuthModal.vue?vue&type=script&lang=js&"
export * from "./MenuAuthModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480129dc",
  null
  
)

export default component.exports